export default {
    data() {
        return {
            width: null,
            height: null
        };
    },
    mounted() {
        this.width = document.documentElement.clientWidth;
        this.height = document.documentElement.clientHeight;
    }
}